module.exports = __webpack_public_path__ + "static/media/sRuleCrt.8dd17410.png";